import { render } from "./PaginationBar.vue?vue&type=template&id=a1ce5552"
import script from "./PaginationBar.vue?vue&type=script&lang=js"
export * from "./PaginationBar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__